import ApiGenericServicesData from "service/ApiGenericServicesData";

export default class DetalleHojaAfiliacionAdhesion extends ApiGenericServicesData {
    constructor() {
        super("detalleHojaAfiliacionAdhesion");
    }

    getDetalleHoja(idHoja) {
        return this.customGET("list/" + idHoja);
    }

    eliminarAfiliado(id) {
        return this.customGET("delete/" + id);
    }
}